import { render, staticRenderFns } from "./BaseSideNav.vue?vue&type=template&id=2f72b64c"
import script from "./BaseSideNav.vue?vue&type=script&lang=ts"
export * from "./BaseSideNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports